import "./App.css";
import RoutesApp from "./routes";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import Theme from "./globalStyles/Theme";
import ContextProvider from "./contexts";
import { PrimeReactProvider } from "primereact/api";
import { addLocale } from "primereact/api";
import "primereact/resources/themes/saga-orange/theme.css";
import "react-toastify/dist/ReactToastify.css";

function App() {
  addLocale("pt", {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: [
      "domingo",
      "segunda",
      "terça",
      "quarta",
      "quinta",
      "sexta",
      "sábado",
    ],
    dayNamesShort: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
    monthNames: [
      "janeiro",
      "fevereiro",
      "março",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro",
    ],
    monthNamesShort: [
      "jan",
      "fev",
      "mar",
      "abr",
      "mai",
      "jun",
      "jul",
      "ago",
      "set",
      "out",
      "nov",
      "dec",
    ],
    today: "Hoje",
    clear: "Limpar",
  });

  return (
    <ThemeProvider theme={Theme}>
      <PrimeReactProvider theme={Theme}>
        <BrowserRouter>
          <ContextProvider>
            <ToastContainer
              style={{ zIndex: 9000000000 }}
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
            <RoutesApp />
          </ContextProvider>
        </BrowserRouter>
      </PrimeReactProvider>
    </ThemeProvider>
  );
}

export default App;
